export default __webpack_public_path__ + "static/media/opening-a-bank-account-01 1.0b8d65ca.svg";